import HookFormInputField from "@/components/form/HookFormInputField";
import AuthContainer from "@/components/ui/authContainer";
import { IconButton } from "@/components/ui/Buttons";
import { VerifyToken } from "@/utils/verifyToken";
import { useResetPasswordMutation } from "@/redux/feature/auth/authApi";
import { setUser } from "@/redux/feature/auth/authSlice";
import { useAppDispatch } from "@/redux/hooks/hooks";
import {
  ResetPassFormValues,
  resetPasswordSchema,
} from "@/validation/form.schema";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import {
  Link,
  ScrollRestoration,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

const SetNewPassword = () => {
  const [isLoading, setLoading] = useState(false);
  const [resetPassword] = useResetPasswordMutation();
  const [error, setError] = useState("");
  // Get search params from the URL
  const [searchParams] = useSearchParams();

  // Extract email and token from the URL
  const email = searchParams.get("email");
  const token = searchParams.get("token");
  const welcomeOnboard = searchParams.get("welcomeOnboard");
  const methods = useForm<ResetPassFormValues>({
    resolver: zodResolver(resetPasswordSchema),
  });
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onSubmit = async (data: ResetPassFormValues) => {
    // console.log(data);
    if (data.newPassword !== data.confirmPassword) {
      setError(`Password didn't matched`);
      return;
    }
    setError(``);

    const payload = {
      token: token,
      email: email as string,
      newPassword: data.newPassword,
    };

    try {
      setLoading(true);
      const res = await resetPassword(payload).unwrap();
      console.log(res);
      if (res.success) {
        setLoading(false);
        toast.success("Success");
        const user = VerifyToken(res.data.accessToken);
        dispatch(setUser({ user: user, token: res.data.accessToken }));
        navigate("/dashboard");
      }
    } catch (err) {
      setLoading(false);
      toast.error("Something Went Wrong");

      const error = err as { data?: { errorSource?: { message: string }[] } };

      if (error?.data) {
        error?.data?.errorSource?.forEach((item) => toast.error(item.message));
      }

      console.log(err);
    }
  };

  return (
    <AuthContainer
      title={`${welcomeOnboard ==='true'?"Welcome Onboard":"Set new password"}`}
      subtitle={`${welcomeOnboard ==='true'?"Please Set a new Password to continue":"Get access to your account by resetting your password"}`}
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)} className="mt-7">
          <HookFormInputField
            placeholder="Enter Password"
            name="newPassword"
            label="Password"
            type="password"
          />
          <HookFormInputField
            placeholder="Enter Confirm Password"
            name="confirmPassword"
            label="Enter Confirm Password"
            type="password"
          />
          {error && (
            <p className="text-red-500 pb-2 -translate-y-3 text-sm">{error}</p>
          )}
          <IconButton type="submit" className="w-full bg-blue-700 text-white">
            {isLoading ? (
              <div className="flex space-x-2 justify-center items-center py-2">
                <span className="sr-only">Loading...</span>
                <div className="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]"></div>
                <div className="h-2 w-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]"></div>
                <div className="h-2 w-2 bg-white rounded-full animate-bounce"></div>
              </div>
            ) : (
              "Reset password"
            )}
          </IconButton>
        </form>
      </FormProvider>
      <ScrollRestoration />
    </AuthContainer>
  );
};

export default SetNewPassword;
